<template>
  <div
    class="rounded-lg bg-white shadow-xl"
    :class="{ 'overflow-hidden': !overflowVisible }"
  >
    <div class="flex items-center gap-4 rounded-t-lg bg-gray-100 p-3">
      <div class="flex shrink-0 space-x-2">
        <div class="h-3 w-3 rounded-full bg-gray-200" />
        <div class="h-3 w-3 rounded-full bg-gray-200" />
        <div class="h-3 w-3 rounded-full bg-gray-200" />
      </div>
      <div
        v-if="$slots.url"
        class="flex min-w-0 grow items-center gap-2 rounded-md bg-white px-3 py-1.5 text-xs text-gray-600"
      >
        <Icon
          icon="lock"
          class="shrink-0 text-xxs text-gray-400"
        />
        <span class="truncate">
          <slot name="url" />
        </span>
      </div>
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  overflowVisible?: boolean
}>()
</script>
